import _ReservationService from "../../services/reservation-service";
import Fetch from "../fetch";

const ReservationService: IReservationService = new _ReservationService(new Fetch());

export default ReservationService;
